import { Tooltip } from 'antd';
import React, { useState } from 'react';
import { User } from 'react-feather';
import Typography from './typography/Typography';

type Props = {
  image?: string;
  name?: string;
  addClass?: string;
  size?: number;
  info?: {
    title: string;
    subtitle: string;
  };
};

export const EmployeeThumb = ({
  image,
  name,
  addClass = '',
  size = 8,
  info,
}: Props) => {
  const sizeClass = `h-${size} w-${size}`;

  // State for fallback
  const [imgSrc, setImgSrc] = useState(image);

  return (
    <>
      <span>
        {imgSrc ? (
          <Tooltip title={name}>
            <img
              src={imgSrc}
              alt={name}
              onError={() => setImgSrc('https://picsum.photos/200')}
              className={`rounded-full ring-2 outline outline-2 outline-offset-2 outline-blue-700 ring-gray-100 ${sizeClass} hover:scale-125 transition-all ${addClass}`}
            />
          </Tooltip>
        ) : name ? (
          <Tooltip title={name}>
            <div className="relative inline-flex items-center justify-center w-8 h-8 hover:scale-125 transition-all overflow-hidden bg-white rounded-full dark:bg-slate-900 ring-2 ring-blue-700">
              <span className="font-medium text-gray-700 dark:text-gray-200 cursor-default">
                {name.charAt(0)}
              </span>
            </div>
          </Tooltip>
        ) : (
          <Tooltip title={'CMC'}>
            <div
              className={`relative rounded-full ring-2 p-0.5 ring-blue-700 ${sizeClass} hover:scale-125 transition-all flex justify-center items-center ${addClass}`}
            >
              <User className="text-gray-700 dark:text-gray-200" />
            </div>
          </Tooltip>
        )}
      </span>

      {info && (
        <div>
          <Typography tag={'p'} type={'bold'}>
            {info?.title}
          </Typography>
          <Typography tag={'p'} type={'label'}>
            {info?.subtitle ?? 'Niet toegewezen'}
          </Typography>
        </div>
      )}
    </>
  );
};

export default EmployeeThumb;
